//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import {DataGrid} from '@mui/x-data-grid';
import {FOCUS_RING} from 'theme';

//---------------------------------------------------------
// Functional Component
//---------------------------------------------------------
export function SimpleTable(props: {columns: any; rows: any; onRowClick?: (row: any) => void}) {
	const {columns, rows, onRowClick} = props;

	return (
		<DataGrid
			rows={rows}
			columns={columns}
			initialState={{pagination: {paginationModel: {pageSize: 5}}}}
			checkboxSelection={false}
			columnHeaderHeight={rows.length <= 5 ? 35 : 25}
			rowHeight={rows.length <= 5 ? 35 : 25}
			pageSizeOptions={[5]}
			disableColumnResize={true}
			disableColumnSorting={true}
			disableColumnMenu={true}
			hideFooterPagination={rows.length <= 5}
			hideFooter={rows.length <= 5}
			disableRowSelectionOnClick
			isRowSelectable={() => false}
			onRowClick={params => {
				if (onRowClick) onRowClick(params.row);
			}}
			sx={{
				border: 0,
				cursor: 'pointer',
				'& .MuiDataGrid-columnHeaders .MuiDataGrid-columnHeaderTitleContainer': {typography: 'caption'},
				'& .MuiDataGrid-cell': {typography: 'caption', overflow: 'hidden', textOverflow: 'ellipsis', display: 'flex', alignItems: 'center'},
				// Mouse clicks stay ring-free; keyboard navigation keeps the shared
				// focus ring (inset so the 25px row box doesn't clip it).
				'.MuiDataGrid-cell:focus': {outline: 'none'},
				'.MuiDataGrid-cell:focus-within': {outline: 'none'},
				'.MuiDataGrid-cell:focus-visible': {...FOCUS_RING, outlineOffset: '-2px'},
				'& .MuiDataGrid-columnSeparator': {display: 'none'},
			}}
		/>
	);
}
